import { homeownerRenderer } from "./homeowner/renderer";
import { organizationRenderer } from "./organization/renderer";
import { ClientProfileRenderer } from "./registry.types";
import { ClientProfileOwnerType, assertNeverClientProfileType } from "./types";

type RendererRegistry = {
  [K in ClientProfileOwnerType]: ClientProfileRenderer<K>;
};

export const clientProfileRenderers: RendererRegistry = {
  HOMEOWNER: homeownerRenderer,
  ORGANIZATION: organizationRenderer,
};

export const getClientProfileRenderer = <T extends ClientProfileOwnerType>(
  ownerType: T
): ClientProfileRenderer<T> => {
  const renderer = clientProfileRenderers[ownerType];
  if (!renderer) {
    return assertNeverClientProfileType(ownerType as never) as never;
  }
  return renderer as ClientProfileRenderer<T>;
};
